interface StarRatingProps {
  rating: number;
  size?: 'sm' | 'md';
  showValue?: boolean;
}

export default function StarRating({ rating, size = 'sm', showValue = true }: StarRatingProps) {
  const stars = Math.round(rating / 2);
  const iconSize = size === 'sm' ? 'text-xs' : 'text-sm';
  return (
    <div className="flex items-center gap-1">
      <div className={`flex items-center gap-0.5 ${iconSize} text-accent-500`}>
        {[1, 2, 3, 4, 5].map((i) => (
          <i key={i} className={i <= stars ? 'ri-star-fill' : 'ri-star-line text-foreground-300'}></i>
        ))}
      </div>
      {showValue && <span className="text-xs font-semibold text-accent-600">{rating.toFixed(1)}</span>}
    </div>
  );
}